import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

function FooterLines({ children, className, ...rest }) {
	return (
		<div className={`footer ${className}`} {...rest}>
			{children}
			<div className="footerLineCont">
				<div className="footerLine lightBlue"></div>
				<div className="footerLine darkBlue"></div>
			</div>
		</div>
	);
}
FooterLines.defaultProps = {
	className: ''
};
FooterLines.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};
export default FooterLines;
